import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  warehouses: [],
  total_pages: 0,
  total_results: 0
};
export const useWarehouseListFetch = () => {
  const auth = useAuth();
  const [statewh, setStatewh] = useState(initialState);
  const [searchValuewh,setSearchValuewh] = useState('');
  const [includeInactive,setIncludeInactivewh] = useState(false)
  const [triggerwh, setTriggerwh] = useState(false);
  const [loadingwh, setLoadingwh] = useState(false);
  const [errorwh, setError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use fetch")
  
  console.log(searchValuewh)
  const fetchWarehouseList = async(searchValue)=>{
    try {
      setLoadingwh(true);
      setError(false);
     console.log("binne fetchstockitemslist")
      const data = await API.fetchWarehouses(searchValue,"",includeInactive,"",accessToken)
     
      console.log(data.warehouses)
      setStatewh({  
        ...data
        
      }
      )

      setLoadingwh(false)
      setTriggerwh(false)

    } catch (error) {
      console.log(error)
      setError(true);
    }
  }

  useEffect(()=>{
    console.log("useEffect is getrigger")
    setStatewh(initialState)
    fetchWarehouseList(searchValuewh)
  },[searchValuewh,triggerwh,includeInactive]);

return{statewh,loadingwh,errorwh,setSearchValuewh,setIncludeInactivewh,setLoadingwh,setTriggerwh};


};
